// extracted by css-extract-rspack-plugin
export default {"documentList":"ReuploadView_documentList__+fCCa","documentListItem":"ReuploadView_documentListItem__9LqkX","recommendedBadge":"ReuploadView_recommendedBadge__nS0Ab"};